import { Select } from "antd";
import { useEffect, useState } from "react";

type AsyncSelectProps<T> = {
    fetchOptions: () => Promise<T[]>;
    value?: number | number[];
    onChange?: (value: any) => void;
    labelKey: keyof T;
    valueKey: keyof T;
    placeholder?: string;
    disabled?: boolean;
    mode?: "multiple" | "tags";
};

export const AsyncSelect = <T,>({
    fetchOptions,
    value,
    onChange,
    labelKey,
    valueKey,
    placeholder,
    disabled,
    mode,
}: AsyncSelectProps<T>) => {
    const [options, setOptions] = useState<T[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let mounted = true;

        async function loadOptions() {
            try {
                setLoading(true);

                const data = await fetchOptions();

                if (mounted) {
                    setOptions(data);
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        }

        loadOptions();

        return () => {
            mounted = false;
        };
    }, [fetchOptions]);

    return (
        <Select
            mode={mode}
            disabled={disabled}
            showSearch
            allowClear
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            loading={loading}
            style={{ width: "100%" }}
            optionFilterProp="label"
            filterOption={(input, option) =>
                (option?.label as string)
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
            }
            options={options.map((opt: any) => ({
                label: String(opt[labelKey]),
                value: opt[valueKey],
            }))}
        />
    );
};